// @flow
import modalActions from '../../actions/modals';
import {
    SEARCH_MODAL,
    FILTERS_MODAL,
    DATE_MODAL,
    GUEST_MODAL,
    FILTERS_DATES_MODAL,
    FILTERS_GUEST_MODAL
} from '../../actions/modals';
import {media} from '../../utils/breakpoints';

import type {ConnectedReactRouterLocationAction} from '../../actions/types';
import type {Store} from '../../reducers';

const modals = (store: Store, action: ConnectedReactRouterLocationAction) => {
    const {viewport, modals: modalState} = store.getState();
    const isMobile = !media(viewport.breakpoint, {minWidth: 'SM_MIN'});
    const {search} = action.payload.location;

    if (isMobile) {
        [
            SEARCH_MODAL,
            FILTERS_MODAL,
            DATE_MODAL,
            GUEST_MODAL,
            FILTERS_DATES_MODAL,
            FILTERS_GUEST_MODAL
        ].forEach((type) => {
            const query = new URLSearchParams(search);
            if ((query.get('modal') || '').includes(type)) {
                store.dispatch(modalActions.toggle(type, true));
            } else if (modalState[type].isOpen) {
                store.dispatch(modalActions.toggle(type, false));
            }
        });
    }
};

export default modals;
